module.exports = '/ng-templates/features/record/kp-documents-slider/kp-documents-slider.tpl.ftl';
